import { render, staticRenderFns } from "./ArchivesPage.vue?vue&type=template&id=19a1d475&scoped=true&"
import script from "./ArchivesPage.vue?vue&type=script&lang=js&"
export * from "./ArchivesPage.vue?vue&type=script&lang=js&"
import style0 from "./ArchivesPage.vue?vue&type=style&index=0&id=19a1d475&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a1d475",
  null
  
)

export default component.exports